export const getOrderUrl = (selfLink: string, orderId: string) =>
  !selfLink?.includes('/v2/') ? `/purchase-orders-corrogo/${orderId}` : `/purchase-orders/${orderId}`;
